export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5339.171a6cd6.jpg";